import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { EllipsisSolidIcon } from '@fiverr-private/icons';
import { translate } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { IconButton } from '../../IconButton';
import { DropdownMenu } from '../../DropdownMenu';
import { COPIES_PREFIX } from '../../constants';
import classes from './OverlayDropdown.module.scss';

interface OverlayDropdownProps {
  sellerUserName: string;
  gigSlug: string;
  onGigLinkClick: () => void;
}

export const OverlayDropdown = ({ sellerUserName, gigSlug, onGigLinkClick }: OverlayDropdownProps) => {
  const hrefToGig = pathfinder('gig_page', { username: sellerUserName, slug: gigSlug });

  const menuItems = [
    {
      id: 'see_gig',
      name: translate(`${COPIES_PREFIX}.see_gig`),
      onClick: () => {
        window.open(hrefToGig);
        onGigLinkClick();
      },
    },
  ];

  return (
    <DropdownMenu
      menuItems={menuItems}
      trigger={
        <IconButton transparent className={classes.iconButton}>
          <Icon size={16} color="white" className={classes.icon}>
            <EllipsisSolidIcon />
          </Icon>
        </IconButton>
      }
    />
  );
};
